import styled from 'styled-components';
import InsuranceActiveIconSvg from '../../assets/header/travelInsuranceActive.svg';

const InsuranceActiveIcon = styled(
  InsuranceActiveIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '3.3rem'};
  height: ${props => props.height || '3.3rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill};
`;

export default InsuranceActiveIcon;
